import { useState, useEffect, useMemo } from "react";
import { ChevronDown } from "lucide-react";

// Client-side "show more" pager to keep long lists from rendering thousands of rows at once.
export function usePaged(items, { step = 25, resetKey } = {}) {
  const [limit, setLimit] = useState(step);
  useEffect(() => { setLimit(step); }, [resetKey, step]);
  const list = items || [];
  const visible = useMemo(() => list.slice(0, limit), [list, limit]);
  const remaining = Math.max(0, list.length - limit);
  return { visible, hasMore: remaining > 0, remaining, total: list.length, showMore: () => setLimit((l) => l + step) };
}

export function ShowMore({ remaining, onClick, label = "Show more", className = "", testid = "show-more-btn" }) {
  if (!remaining) return null;
  return (
    <div className={`flex justify-center pt-4 ${className}`}>
      <button type="button" data-testid={testid} onClick={onClick}
        className="inline-flex items-center gap-1.5 rounded-full border border-sand-200 bg-white px-4 py-2 text-sm font-semibold text-ink/70 hover:border-ink hover:text-ink transition-colors">
        {label} <span className="text-ink/40">({remaining} more)</span> <ChevronDown className="h-4 w-4" />
      </button>
    </div>
  );
}
